import React, { useState } from 'react'
import useFileUpload from 'hooks/useFileUpload'
import styles from './PdfField.module.scss'
import pdfImg from 'components/UI/icons/constructor-edit/pdf-img.png'
import { SuperButton } from 'components/UI/SuperButton/SuperButton'
import { ReactComponent as UploadIcon } from 'components/UI/icons/constructor-edit/upload.svg'

const PdfField = ({ onChange, showSize = false }) => {
  const { hostname, protocol } = window.location
  const [path, setPath] = useState()
  const [fileSize, setFileSize] = useState(null)
  const [error, setError] = useState(false)

  const onUploadEnd = (path) => {
    setPath(path)
    onChange(path, file.name)
  }

  const { refInput, file, setFile } = useFileUpload({
    url: 'files/file_upload',
    onUploadEnd,
  })

  return (
    <div className={styles.box}>
      {path ? (
        <div className={styles.preview}>
          <a
            target='_blank'
            rel='noopener noreferrer'
            href={`${hostname.includes('localhost') ? 'https://dev.phoenix24.io' : `${protocol}//${hostname}`}${path}`}
          >
            <img src={pdfImg} alt='pdf_image' />
          </a>
          {showSize && fileSize && (
            <span className={styles.sizeTitle}> {fileSize} МБ</span>
          )}
        </div>
      ) : (
        <div>
          {error && <span style={{ color: 'red' }}>Неверный формат файла</span>}
        </div>
      )}
      <input
        accept='application/pdf'
        style={{ display: 'none' }}
        type='file'
        ref={refInput}
        onChange={(e) => {
          const selectedFile = e.target.files[0]
          if (selectedFile?.type === 'application/pdf') {
            setError(false)
            setFile(selectedFile)
            setFileSize((selectedFile.size / (1024 * 1024)).toFixed(2))
          } else {
            setError(true)
            setFileSize(null)
          }
        }}
      />

      <SuperButton
        className={styles.uploadBtn}
        variant='confirm'
        onClick={() => refInput.current.click()}
      >
        <UploadIcon />
        {file ? 'Выбрать другой PDF' : 'Загрузить PDF'}
      </SuperButton>
    </div>
  )
}

export default PdfField
